import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { Col, Row } from 'reactstrap';
import { useUsers } from 'views/Report/Protocol/hooks/useUsers';
import { useListOpportunityStagesByRecordType } from 'views/CRM/OpportunityStages/hooks/useListOpportunityStagesByRecordType';
import FlexSelect from 'components/Inputs/FlexSelect';
import { opportunityTypes } from 'views/CRM/shared/utils/opportunityTypes';
import { useGetLostReasonByEntity } from 'views/CRM/hooks/useGetLostReasonByEntity';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import Select from 'react-select/async';
import { useSearchAccounts } from 'views/CRM/Account/hooks/useSearchAccounts';

import SelectContact from 'react-select/creatable';
import { toast } from 'react-toastify';
import { custom_select } from 'assets/styles/multiple_select';
import ClientService from '../../../Clients/service/index.js';
import { allowedFields } from '../utils/entitiesName.js';
const DefaultFieldsFilterFormOpportunity = ({
  control,
  setValue,
  recordTypeId,
  defaultFields
}) => {
  const { userList } = useUsers();
  const [filterListLostReason, setFilterListLostReason] = useState([]);
  const { isSearching, filterAccounts } = useSearchAccounts();
  const [account, setAccount] = useState();
  const [clientToSelect, setClientsToSelect] = useState([]);
  const [timeoutID, setTimeoutID] = useState(null);

  const [contact, setContact] = useState();

  const {
    opportunityStages,
    getOpportunityStagesByRecordType,
    isLoadingOpportunityStages
  } = useListOpportunityStagesByRecordType();

  const { listLostReason } = useGetLostReasonByEntity({
    entity: entitiesName.OPPORTUNITY,
    recordTypeId: recordTypeId || 0
  });

  const seachClientSelect = (value) => {
    if (typeof timeoutID === 'number') {
      clearTimeout(timeoutID);
    }
    setTimeoutID(
      setTimeout(() => {
        handleGetClient(value);
      }, 1200)
    );
  };

  useEffect(() => {
    if (!listLostReason || !recordTypeId) {
      setFilterListLostReason([]);
      return;
    }
    const options =
      Array.isArray(listLostReason) && listLostReason[0]?.options
        ? listLostReason[0].options
        : [];
    const formattedOptions = options
      .filter((option) => option.recordTypeIds.includes(Number(recordTypeId)))
      .map((option) => ({ label: option.value, value: option.value }));

    setFilterListLostReason(formattedOptions);
  }, [listLostReason, recordTypeId]);

  useEffect(() => {
    getOpportunityStagesByRecordType(recordTypeId);
  }, [getOpportunityStagesByRecordType, recordTypeId]);

  const sortData = (data) => {
    return data.sort((a, b) => {
      const keyA = a.name || a.nome;
      const keyB = b.name || b.nome;
      return keyA.toLowerCase().localeCompare(keyB.toLowerCase());
    });
  };

  const handleGetClient = (value) => {
    if (value) {
      ClientService.getAllFilter('cliente', '', 'ALL', {
        nome: value,
        email: value
      })
        .then((response) => {
          const { content } = response.data;
          const sortClientsArray = sortData(content);
          const setData = sortClientsArray.map((client) => {
            return {
              email: client.email,
              telefone: client.telefone,
              label: client.nome,
              value: client.id
            };
          });
          setClientsToSelect(setData);
        })
        .catch((err) => {
          const message =
            (err.response && err.response.data) || 'Erro ao carregar contatos';
          toast.error(message, {
            autoClose: 3000,
            closeOnClick: true
          });
        });
    } else {
      setClientsToSelect();
    }
  };

  const fieldsToRender =
    defaultFields && defaultFields.length > 0
      ? defaultFields.filter((f) =>
          allowedFields.some((a) => a.value === f.value)
        )
      : [];

  return (
    <>
      <Row>
        {fieldsToRender.map((field) => {
          if (field.value === 'stageId') {
            return (
              <Col xs="12" sm="6" md="6" lg="4" key={field.value}>
                <div className="form-group">
                  <label className="form-control-label">{field.label}</label>
                  <Controller
                    render={(props) => (
                      <FlexSelect
                        dataOptions={opportunityStages || []}
                        isMulti={true}
                        value={props.value}
                        valueController={setValue}
                        fieldName={field.value}
                        labelName="name"
                        valueName="id"
                        isClearable={true}
                        closeMenuOnSelect={true}
                        disabled={isLoadingOpportunityStages}
                      />
                    )}
                    control={control}
                    name={field.value}
                    defaultValue=""
                  />
                </div>
              </Col>
            );
          }
          if (field.value === 'responsibleLogin') {
            return (
              <Col xs="12" sm="6" md="6" lg="4" key={field.value}>
                <div className="form-group">
                  <label className="form-control-label">{field.label}</label>
                  <Controller
                    render={(props) => (
                      <FlexSelect
                        dataOptions={userList || []}
                        isMulti={true}
                        value={props.value}
                        valueController={setValue}
                        fieldName={field.value}
                        labelName="name"
                        valueName="login"
                        isClearable={true}
                        closeMenuOnSelect={false}
                      />
                    )}
                    control={control}
                    name={field.value}
                    defaultValue=""
                  />
                </div>
              </Col>
            );
          }
          if (field.value === 'type') {
            return (
              <Col xs="12" sm="6" md="6" lg="4" key={field.value}>
                <div className="form-group">
                  <label className="form-control-label">{field.label}</label>
                  <Controller
                    render={(props) => (
                      <FlexSelect
                        dataOptions={opportunityTypes || []}
                        isMulti={false}
                        value={props.value}
                        valueController={setValue}
                        fieldName={field.value}
                        labelName="name"
                        valueName="value"
                        isClearable={true}
                        closeMenuOnSelect={true}
                      />
                    )}
                    control={control}
                    name={field.value}
                    defaultValue={null}
                  />
                </div>
              </Col>
            );
          }
          if (field.value === 'contactId') {
            return (
              <Col xs="12" sm="6" md="6" lg="4" key={field.value}>
                <div className="form-group">
                  <label className="form-control-label">{field.label}</label>
                  <Controller
                    render={(props) => (
                      <SelectContact
                        isClearable
                        allowCreateWhileLoading={false}
                        isValidNewOption={() => false}
                        fieldName={field.value}
                        valueController={setValue}
                        placeholder="Busca rápida"
                        styles={custom_select}
                        options={clientToSelect}
                        onInputChange={seachClientSelect}
                        onChange={(data) => {
                          if (data) {
                            const { value, label } = data;
                            setContact({
                              label,
                              value
                            });
                            setValue(field.value, value);
                          } else {
                            setContact(null);
                            setValue(field.value, null);
                          }
                        }}
                        value={
                          contact
                            ? {
                                label: contact.label,
                                value: contact.id
                              }
                            : ''
                        }
                        defaultValue={
                          contact
                            ? {
                                label: contact.label,
                                value: contact.id
                              }
                            : ''
                        }
                      />
                    )}
                    control={control}
                    name={field.value}
                    defaultValue=""
                  />
                </div>
              </Col>
            );
          }
          if (field.value === 'accountId') {
            return (
              <Col xs="12" sm="6" md="6" lg="4" key={field.value}>
                <div className="form-group">
                  <label className="form-control-label">{field.label}</label>
                  <Controller
                    render={(props) => (
                      <Select
                        styles={custom_select}
                        placeholder="Busca rápida"
                        isClearable={true}
                        fieldName={field.value}
                        valueController={setValue}
                        isLoading={isSearching}
                        loadingMessage={() => 'Buscando...'}
                        noOptionsMessage={({ inputValue }) =>
                          !inputValue
                            ? 'Digite para pesquisar'
                            : 'Nenhum resultado encontrado'
                        }
                        loadOptions={async (inputValue) => {
                          const res = await filterAccounts(inputValue);
                          return (
                            res &&
                            res.map((account) => ({
                              label: account.name,
                              value: account.id
                            }))
                          );
                        }}
                        onChange={(data) => {
                          if (data) {
                            const { value, label } = data;
                            setAccount({
                              label,
                              value
                            });
                            setValue(field.value, value);
                          } else {
                            setAccount(null);
                            setValue(field.value, null);
                          }
                        }}
                        value={
                          account
                            ? {
                                label: account.label,
                                value: account.id
                              }
                            : ''
                        }
                        defaultValue={
                          account
                            ? {
                                label: account.label,
                                value: account.id
                              }
                            : ''
                        }
                      />
                    )}
                    control={control}
                    name={field.value}
                    defaultValue=""
                  />
                </div>
              </Col>
            );
          }
          if (field.value === 'lostReason') {
            if (!recordTypeId) return null;
            return (
              <Col xs="12" sm="6" md="6" lg="4" key={field.value}>
                <div className="form-group">
                  <label className="form-control-label">{field.label}</label>
                  <Controller
                    render={(props) => (
                      <FlexSelect
                        isClearable={true}
                        placeholder="Selecione o motivo"
                        dataOptions={filterListLostReason || []}
                        isMulti={false}
                        value={props.value}
                        valueController={setValue}
                        fieldName={field.value}
                        labelName="value"
                        valueName="value"
                        closeMenuOnSelect={true}
                      />
                    )}
                    control={control}
                    name={field.value}
                    defaultValue=""
                  />
                </div>
              </Col>
            );
          }
        })}
      </Row>
    </>
  );
};

export default DefaultFieldsFilterFormOpportunity;
